<script setup lang="ts">
  import { ExternalLink } from "lucide-vue-next";
  import DetailSection from "./DetailSection.vue";
  import type { Histo } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    histo: Histo;
  }>();
</script>

<template>
  <DetailSection title="Links">
    <li>
      <a
        v-if="histo.crm_id"
        :href="`https://app.hubspot.com/contacts/9187193/deal/${histo.crm_id}`"
        target="_blank"
        rel="noopener"
        class="text-status-info-strong hover:underline inline-flex items-center gap-1">
        <ExternalLink class="h-3 w-3" />
        Hubspot
      </a>
      <span
        v-else
        class="text-foreground/50"
        >Hubspot (not available)</span
      >
    </li>
    <li>
      <a
        v-if="histo.token_pricer"
        :href="`/admin/pricer/projects/${histo.token_pricer}?section=summary`"
        target="_blank"
        rel="noopener"
        class="text-status-info-strong hover:underline inline-flex items-center gap-1">
        <ExternalLink class="h-3 w-3" />
        Pricer
      </a>
      <span
        v-else
        class="text-foreground/50"
        >Pricer (not available)</span
      >
    </li>
    <li>
      <a
        :href="`/surveys/${histo.token}/dashboards`"
        target="_blank"
        rel="noopener"
        class="text-status-info-strong hover:underline inline-flex items-center gap-1">
        <ExternalLink class="h-3 w-3" />
        Results
      </a>
    </li>
  </DetailSection>
</template>
